import axios from 'axios';
import { API, API_SCHEURICH } from '../hooks/config';
import { APIS } from '../hooks/config';
import { tokerUser } from './user';
import regeneratorRuntime from "regenerator-runtime";

export const getCategories = () => {
    return new Promise((resolve) => {
      axios.get(`${API}/categories`).then((resFansa) => {
        axios.get(`${API_SCHEURICH}/categories`).then((resScheurich) => {
          resolve({
            fansa: resFansa.data,
            scheurich: resScheurich.data,
          });
        });
      });
    });
  };
  

export const getOtherCategories = () => {
    return new Promise((resolve) => {
      axios.get(`${API}/other-categories`).then((resFansa) => {
        axios.get(`${API_SCHEURICH}/other-categories`).then((resScheurich) => {
          resolve(resFansa.data.concat(resScheurich.data));
        });
      });
    });
};

export const getProducts = () => {
    return new Promise((resolve) => {
      axios.get(`${API}/products`).then((resFansa) => {
        axios.get(`${API_SCHEURICH}/products`).then((resScheurich) => {
          resolve({
            fansa: resFansa.data,
            scheurich: resScheurich.data,
          });
        });
      });
    });
  };

export const getProductsOutlet = () => {
    console.log("getProductsOutlet",API);
    return axios.get(`${API}/products-outlet`)
}

export const getProductsExpositors = () => {
    return axios.get(`${API}/products-expositores`)
}

 export const getProductsImplantations = () => {
     return axios.get(`${API_SCHEURICH}/products-implantations`)
 }

export const getProductsPromoA = () => {
    return axios.get(`${API}/products-promo_a`)
}

export const getProductsPromoB = () => {
    return axios.get(`${API}/products-promo_b`)
}

export const getProductsPromoC = () => {
    return axios.get(`${API}/products-promo_c`)
}

export const getZones = () => {
    return axios.get(`${APIS['fansa']}/zone`)
}

export const getBudgetsUser = async (userId) => {
    const token = await tokerUser();
    return axios.get(`${API}/protected/budgets-user/${userId}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
};

export const getCartsUser = async (userId) => {
    const token = await tokerUser();
    return axios.get(`${API}/protected/carts-user/${userId}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
};

export const getCatalogs = () => {
    return axios.get(`${API}/catalog`)
}

export const getColors = () => {
    return axios.get(`${API}/colors`)
}

export const getCharacteristics = () => {
    return axios.get(`${API}/characteristics`)
}

export const getShapes = () => {
    return axios.get(`${API}/shapes`)
}

export const getCollections = (value = '') => {
    if (value === '') {
        return axios.get(`${API}/collections`)
    } else {
        return axios.get(`${API}/collections/${value}`)
    }
}

export const getPromosHome = () => {
    return axios.get(`${API}/promos-home`)
}

export const getState = () => {
    return axios.get(`${API}/state-system`)
}